module.exports = __webpack_public_path__ + "static/img/tina.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/tina.jpg
// module id = gh8E
// module chunks = 0